import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './base.js';
import './index.css';

// Тут хранится информация о том на какой стадии перезапуск List_Cards, 0 это уже закончен, 1 это в процессе
window.reset_status = 0;

window.select_tab = 0;
window.tabs = [];

// Объект с изображениями
window.images = {};

// Объекты с размерами бумаги, типами бумаги и ценами
window.sizes = {};
window.types = {};
window.prices = {};

// Масштаб карточки
window.card_size = 1;
// Размеры карточки
window.canvasSize = 150;


window.styledLog = function (element, operation, params) {
    function getStyledParam(key, value) {
        let valueType = typeof value;
        let color;
        switch (valueType) {
          case 'number':
            color = 'lightblue'; // Blue color for numbers
            break;
          case 'string':
              color = 'white'; // White color for strings
              break;
          case 'boolean':
              color = value ? '#61ff61' : '#ff5656'; // Green for true, red for false
              break;
          default:
              color = 'white'; // White color for other types
        }
        return {'text': `%c${key}:%c ${value}`, "color": color};
    }

    let paramsParts = [];
    let styles = [];
    for (let [key, value] of Object.entries(params)) {
        let {text, color} = getStyledParam(key, value);
        paramsParts.push(text);
        styles.push(`color: white;`); // This line had an issue where 'color' was not defined in this scope
        styles.push(`color: ${color};`); // This line had an issue where 'color' was not defined in this scope
    }

    console.log(
        `%c[React] %c${element} => %c${operation} %c\n${paramsParts.join('\n')}`,
        "color: lightgreen;", // Light green color for React label
        "color: lightblue;", // Light blue color for element
        "color: lightcoral;", // Light coral color for operation
        "color: purple;", // Purple color for the parameters
        ...styles
    );
}

/**
 * Функция для рендеринга компонента App с новым идентификатором и состоянием сброса.
 *
 * @param {boolean} full_reset - Если true, выполняется полный сброс, если false - частичный.
 */
window.reset_element = function (full_reset = false) {
  window.reset_status = 1;
  let id = Math.random();

  // window.styledLog("List_Cards", "перезапущен", {
  //   "Полный сброс": full_reset,
  // })

  root.render(
    <React.StrictMode>
      <App data-id={id} empty_reset={full_reset.toString()} />
    </React.StrictMode>
  );

  if (full_reset == false) {
    window.reset_status = 0;
    setTimeout(() => {window.load_position_list()}, 400)
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
window.reset_element()
